import { userService } from '@libs/data-access/queries'
import { IconButton, SynchronizeIcon, Tooltip } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

import { shouldDisplayForComboPay } from './utils/shouldDisplayForComboPay'
import { shouldDisplayForSilae } from './utils/shouldDisplayForSilae'

type Props = {
  nameInput: string | null
}

export const HRSynchronizedIcon: FC<Props> = ({ nameInput }) => {
  const { t } = usePlanningFormTranslation()
  const permissions = userService.membership.useFeaturePermissions()

  const isHRSynchronized =
    permissions?.hr_silae_hr_synchronisation?.can_read ||
    permissions?.hr_arhia_hr_synchronisation?.can_read

  if (!isHRSynchronized || !nameInput) {
    return null
  }

  const synchronizationChecks = [
    {
      check: shouldDisplayForSilae,
      permission: permissions?.hr_silae_hr_synchronisation?.can_read
    },
    {
      check: shouldDisplayForComboPay,
      permission: permissions?.hr_arhia_hr_synchronisation?.can_read
    }
  ]

  const shouldBeDisplayed = synchronizationChecks.some(
    ({ check, permission }) => check(permission, nameInput)
  )

  if (shouldBeDisplayed) {
    return (
      <Tooltip label={t('membershipCreation.syncSilae.tooltip')}>
        <IconButton
          icon={<SynchronizeIcon />}
          variant='tertiary'
          intent='default'
          size='s'
        />
      </Tooltip>
    )
  }

  return null
}
